import { updateStoredValues } from '../helpers';

// TODO: Add unit tests
const updateCreditVerification = (_ref, walletStorageService) => {
  let {
    types
  } = _ref;
  return payload => async (dispatch, getState) => {
    const paymentsInfo = getState()?.payments;
    const isLoggedIn = getState()?.auth?.isLoggedIn || false;
    const verifiedDate = payload.verified ? new Date().getTime() : null;
    // Update payments local storage values
    const response = await updateStoredValues({
      paymentsInfo,
      payments: {
        creditVerification: {
          ...payload,
          verifiedDate
        }
      },
      walletStorageService,
      isLoggedIn
    });
    if (!response?.success) {
      dispatch({
        type: types.UPDATE_MY_WALLET,
        payload: {
          displayWalletErrorMessage: true
        }
      });
    }
    dispatch({
      type: types.UPDATE_CREDIT_VERIFICATION,
      payload: {
        ...payload,
        verifiedDate
      }
    });
  };
};
export default updateCreditVerification;